import { Box } from '@mui/material';
import { Node } from '@portals/root/src/consumers/Consumer/Consumer';
import React from 'react';

import { Consumer } from '../../../containers/Consumer/Consumer';

interface HeaderFooterSectionProps {
  node: Node | undefined;
}

const HeaderFooterSection: React.FC<HeaderFooterSectionProps> = ({ node }) => {
  if (!node) {
    return null;
  }

  return (
    <Box sx={{ displayPrint: 'none' }}>
      <Consumer node={node} />
    </Box>
  );
};

export default HeaderFooterSection;
